<div class="toast-container position-fixed top-0 end-0 p-2 zindex-toast">
  @for (toast of toastService.toasts; track toast) {
  <ngb-toast
    [header]="toast.headertext"
    [class]="toast.classname"
    [autohide]="toast.autohide"
    [delay]="toast.delay || 5000"
    (hide)="toastService.remove(toast)"
    (hidden)="removeToast()"
  >
    @if (isTemplate(toast)) {
    <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    } @else {
    {{ toast.textOrTpl }}
    }
  </ngb-toast>
  }
</div>
